import * as React from 'react';

function SvgNotificationBlanktip(props) {
  return (
    <svg width={320} height={270} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#fff" d="M0 0h320v270H0z" />
      <path
        d="M158.93 242.826c59.322 0 107.413-48.091 107.413-107.413C266.343 76.09 218.252 28 158.93 28 99.607 28 51.517 76.09 51.517 135.413c0 59.322 48.09 107.413 107.413 107.413z"
        fill="#F5F5F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142.071 206.145v2.861c0 9.915 8.042 17.956 17.965 17.956 9.922 0 17.964-8.041 17.964-17.963v-2.861"
        fill="#fff"
      />
      <path
        d="M142.071 206.145v2.861c0 9.915 8.042 17.956 17.965 17.956 9.922 0 17.964-8.041 17.964-17.963v-2.861"
        stroke="#D9D9D9"
        strokeWidth={2.398}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="notification-blanktip_svg__a" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M176.076 62.67v-8c0-8.822-7.24-15.978-16.185-15.978-8.944 0-16.185 7.156-16.185 15.977v8.002"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M176.076 62.67v-8c0-8.822-7.24-15.978-16.185-15.978-8.944 0-16.185 7.156-16.185 15.977v8.002"
        fill="#fff"
      />
      <path
        d="M176.559 62.67v-8h-.966v8h.966zm0-8c0-9.094-7.462-16.46-16.668-16.46v.965c8.684 0 15.702 6.946 15.702 15.494h.966zm-16.668-16.46c-9.205 0-16.668 7.366-16.668 16.46h.966c0-8.55 7.018-15.495 15.702-15.495v-.965zm-16.668 16.46v8h.966v-8h-.966z"
        fill="#D9D9D9"
        mask="url(#notification-blanktip_svg__a)"
      />
      <path
        d="M176.076 62.67v-8c0-8.822-7.24-15.978-16.185-15.978-8.944 0-16.185 7.156-16.185 15.977v8.002"
        stroke="#E1E4E5"
        strokeWidth={2.398}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.565 114.116c0-28.299 22.94-51.227 51.227-51.227h20.498c28.299 0 51.227 22.94 51.227 51.227v31.623a22.62 22.62 0 006.626 15.986l7.247 7.247a22.62 22.62 0 016.625 15.987c0 11.803-9.565 21.368-21.368 21.368H99.436c-11.804 0-21.368-9.565-21.368-21.368a22.62 22.62 0 016.625-15.987l7.247-7.247a22.619 22.619 0 006.625-15.986v-31.623z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={2.398}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M142.15 95.639H42.4c-6.621 0-11.989 5.367-11.989 11.989v23.471c0 6.621 5.368 11.989 11.99 11.989h99.749c6.621 0 11.989-5.368 11.989-11.989v-23.471c0-6.622-5.368-11.99-11.989-11.99z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={2.398}
      />
      <path
        d="M138.714 110.408H74.717a2.813 2.813 0 000 5.626h63.997a2.812 2.812 0 100-5.626zM114.1 122.364H74.717a2.813 2.813 0 000 5.626H114.1a2.812 2.812 0 100-5.626z"
        fill="#E8E8E8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.02 131.325c-6.558 0-11.876-5.392-11.876-12.043 0-6.651 5.318-12.043 11.876-12.043s11.875 5.392 11.875 12.043c0 6.651-5.317 12.043-11.875 12.043z"
        fill="#38B2A6"
      />
      <path
        d="M54.202 117.275l-5.017 5.353-3.012-3.211"
        stroke="#fff"
        strokeWidth={2.139}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.16 90.245c-13.407 0-24.277-11.273-24.277-25.177s10.87-25.176 24.277-25.176c13.407 0 24.278 11.272 24.278 25.176 0 13.904-10.871 25.177-24.278 25.177z"
        fill="#FCCE01"
      />
      <path
        d="M135.739 164.621h-99.75c-6.621 0-11.989 5.368-11.989 11.989v23.471c0 6.621 5.368 11.989 11.989 11.989h99.75c6.621 0 11.989-5.368 11.989-11.989V176.61c0-6.621-5.368-11.989-11.989-11.989z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={2.398}
      />
      <path
        d="M132.303 179.39H68.305a2.813 2.813 0 100 5.626h63.998a2.814 2.814 0 000-5.626zM107.688 191.346H68.305a2.813 2.813 0 100 5.626h39.383a2.813 2.813 0 000-5.626z"
        fill="#E8E8E8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.609 200.306c-6.559 0-11.876-5.392-11.876-12.043 0-6.651 5.317-12.043 11.876-12.043 6.558 0 11.875 5.392 11.875 12.043 0 6.651-5.317 12.043-11.875 12.043z"
        fill="#38B2A6"
      />
      <path
        d="M47.79 186.258l-5.017 5.352-3.011-3.211"
        stroke="#fff"
        strokeWidth={2.139}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M292.011 117.22h-99.75c-6.621 0-11.989 5.367-11.989 11.989v23.471c0 6.621 5.368 11.989 11.989 11.989h99.75c6.621 0 11.989-5.368 11.989-11.989v-23.471c0-6.622-5.368-11.989-11.989-11.989z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={2.398}
      />
      <path
        d="M288.575 131.988h-63.997a2.813 2.813 0 000 5.626h63.997a2.812 2.812 0 100-5.626zM263.961 143.943h-39.383a2.813 2.813 0 000 5.626h39.383a2.813 2.813 0 000-5.626z"
        fill="#E8E8E8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M199.881 152.906c-6.558 0-11.876-5.392-11.876-12.043 0-6.65 5.318-12.043 11.876-12.043s11.875 5.393 11.875 12.043c0 6.651-5.317 12.043-11.875 12.043z"
        fill="#38B2A6"
      />
      <path
        d="M204.063 138.855l-5.017 5.353-3.012-3.211"
        stroke="#fff"
        strokeWidth={2.139}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.844 55.31h-4.073l-5.072 3.212v3.842l4.692-2.941h.12V75.8h4.333V55.31z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgNotificationBlanktip;
